import { stepValidationFactory } from 'actions/submissionFormActions';
import scrollToFirstError from 'lib/utils/scrollToFirstError';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CardBody, Form } from 'reactstrap';
import { reduxForm } from 'redux-form';
import InfoLink from '../../components/InfoLink';
import PricingFieldset from './fieldsets/PricingFieldset';
import TicketingQuestionsFieldset from './fieldsets/TicketingQuestionsFieldset';
import FormField from './FormField';
import TicketingUrl from '../TicketingUrl';
import styles from './TicketsForm.scss';

class TicketsForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    geotixEnabled: PropTypes.bool.isRequired,
    premiumEdit: PropTypes.bool,
    currencies: PropTypes.array.isRequired,
    ticketing_type: PropTypes.string,
    ticketing_url_type: PropTypes.string,
    ssoGeotixUrl: PropTypes.string,
  }

  render() {
    const { formErrors, isLoading, ticketing_url_type, premiumEdit, ssoGeotixUrl, geotixEnabled } = this.props;
    const geotixEdit = ticketing_url_type === 'geotix' && premiumEdit;
    return (
      <Form>
        <fieldset disabled={isLoading}>
          <div className="card-header">
            <h4>
              Create Tickets
              <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020923153-Tickets-How-does-ticketing-work-for-your-event"/>
            </h4>
          </div>
          <CardBody className={styles.ticketsContainer}>
            { geotixEdit && <div className='tickets-layover'>
              <a href={ssoGeotixUrl} target='_blank' className='btn btn-success pull-right mt-3 mr-3'>
                <i className="fa fa-ticket mr-2"/>
                Manage Tickets
              </a>
            </div> }
            <TicketingQuestionsFieldset formErrors={formErrors}/>
            <PricingFieldset
              formErrors={formErrors}
              currencies={this.props.currencies}
            />
            <div className="row">
              <div className="col">
                <TicketingUrl
                  formErrors={formErrors}
                  geotixEnabled={geotixEnabled}
                  premiumEdit={premiumEdit}
                />
              </div>
            </div>
          </CardBody>
        </fieldset>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  destroyOnUnmount: false,
  asyncValidate: stepValidationFactory('tickets'),
  onSubmitFail: scrollToFirstError,
  persistentSubmitErrors: true,
})(TicketsForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/TicketsForm.jsx